import { OnDestroy, Pipe, PipeTransform } from "@angular/core";
import { Subject } from "rxjs";

@Pipe({
  name: "keys",
})
export class KeysPipe implements PipeTransform,OnDestroy {
  private destroy$ = new Subject<void>();
  transform(value, args: string[]): any {
    let keys = [];
    for (let key in value) {
      keys.push({ key: key, value: value[key] });
    }
    return keys;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
